import React, { useEffect } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Box, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.palette.KenColors.neutral10,
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 12px',
    border: `1px solid ${theme.palette.KenColors.neutral40}`,
    borderRadius: theme.shape.borderRadius,
  },
  input: {
    border: 'none',
    fontSize: 14,
    width: '100%',
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
    backgroundColor: theme.palette.KenColors.neutral10,
  },
  icon: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export default function KenAutoComplete(props) {
  const classes = useStyles();
  const { options, placeholder, onChange, defaultSearchValue = '' } = props;
  const [inputValue, setInputValue] = React.useState();

  useEffect(() => {
    setInputValue(defaultSearchValue);
  }, [defaultSearchValue]);

  return (
    <Autocomplete
      id="combo-box-demo"
      options={options}
      getOptionLabel={(option) => option.Name || option.ContactName}
      onChange={onChange}
      disableClearable={true}
      onInputChange={(e, value) => {
        setInputValue(value);
      }}
      renderInput={(params) => {
        return (
          <Box ref={params.InputProps.ref} className={classes.root}>
            <input
              type="text"
              {...params.inputProps} // It's not props from renderInput
              className={classes.input}
              placeholder={placeholder}
              value={inputValue}
            />
          </Box>
        );
      }}
    />
  );
}
